import { Table, TableColumn } from "@apex/component-library";
import { DateTime } from "luxon";

import { NotesData } from "../../types";

type Props = { notesData: NotesData };

function Notes({ notesData }: Props) {
  const columns: TableColumn[] = [
    {
      label: "Time Stamp",
      key: "time",
      recordField: "time",
      width: "30%",
      headerHeight: "large",
    },
    {
      label: "Actor",
      key: "actor",
      recordField: "actor",
      width: "15%",
      headerHeight: "large",
    },
    {
      label: "Description",
      key: "description",
      recordField: "description",
      width: "45%",
      headerHeight: "large",
    },
  ];

  const tableData = notesData.noteDetailsList.map((row, index) => ({
    key: index,
    id: index,
    time: `${DateTime.fromISO(row.dateTime, { setZone: true }).toFormat(
      "MM/dd/yyyy hh:mm:ss"
    )} CT`,
    actor: row.actor,
    description: row.description,
  }));

  return <Table columns={columns} data={tableData} />;
}

export default Notes;
